// extracted by mini-css-extract-plugin
export default {"container":"Payment_container__gbc0p","content":"Payment_content__9z7RO","left":"Payment_left__Wxq6o","right":"Payment_right__k-G2y"};